import { render } from "./SaludCoros.vue?vue&type=template&id=a3faa346&scoped=true"
import script from "./SaludCoros.vue?vue&type=script&lang=js"
export * from "./SaludCoros.vue?vue&type=script&lang=js"

import "./SaludCoros.vue?vue&type=style&index=0&id=a3faa346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3faa346"]])

export default __exports__